import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { DaysProvider, TMyGoal, useDays } from '../../context/DaysContext';
import "./User.css"
import Input from '../../components/Input/Input';
import Select from '../../components/Select/Select';
import Graph, { getPercentage, getProgressColor } from '../Stats/Graph';
import { useLocation, useParams } from 'react-router-dom';
import { getProfile, getUser } from '../../controllers/user';
import { TUser, useAuth, useUser } from '../../context/AuthContext';
import { StatsProviderV2 } from '../../context/StatsContextV2';
import ProfileIcon, { TFile } from '../../components/ProfileIcon/ProfileIcon';
import { Likes } from '../../components/Likes/Likes';
import { FriendButton } from '../Friends/SearchUser/SearchUser';
import { getDays } from '../../controllers/days';
import Goals, { getGoalAmountString,  sumDaysProgress } from '../Goals/Goals';
import GoalSkeleton from '../../components/GoalSkeleton';
import UserDays from '../Friends/UserDays/UserDays';
import { TProfile } from '../../controllers/friends';
import { IoMdRefresh } from 'react-icons/io';
import { PageHeader } from '../../components/PageHeader/PageHeader';
import Loader from '../../components/Loader/Loader';
import ProgressDays, { groupProgressesByDay } from '../Goals/ProgressDays';
function useScrollRefresh(ref: React.RefObject<HTMLDivElement>, onTrigger: Function){
    useEffect(()=>{
        const el = ref.current;
    if (!el) return;

    // attach the event listener
    el.addEventListener("mousedown", handleTouchStart);

    function handleTouchStart(startEvent: MouseEvent) {
      const el = ref.current;
      if (!el) return;

      // get the initial Y position
      const initialY = startEvent.clientY;

      el.addEventListener("mousemove", handleTouchMove);
      el.addEventListener("mouseup", handleTouchEnd);

          function handleTouchMove(moveEvent: MouseEvent) {
            const el = ref.current;
            if (!el) return;

            // get the current Y position
            const currentY = moveEvent.clientY;

            // get the difference
            const dy = currentY - initialY;

            if (dy < 0) return;

            // now we are using the `appr` function
            el.style.transform = `translateY(${appr(dy)}px)`;
            }

      function handleTouchEnd() {
        const el = ref.current;
        if (!el) return;

        // cleanup
        el.removeEventListener("mousemove", handleTouchMove);
        el.removeEventListener("mouseend", handleTouchEnd);
      }
    }

    return () => {
      // let's not forget to cleanup
      el.removeEventListener("mousedown", handleTouchStart);
    };
  }, [ref.current]);

    function onTransitionEnd() {
    const el = ref.current;
    if (!el) return;

    // remove transition
    el.style.transition = "";

    // cleanup
    el.removeEventListener("transitionend", onTransitionEnd);
    }


// more code

const MAX = 128;
const k = 0.4;
function appr(x: number) {
  return MAX * (1 - Math.exp((-k * x) / MAX));
}
}
function User() {
    const {userId} = useParams();
    const [user, setUser] = useState<TUser>();
    const me = useUser()
    const [friends, setFriends] = useState<TUser[]>();
    const [goals, setGoals] = useState<TMyGoal[]>([]);
    const [userLoading, setUserLoading] = useState(false);
    const [goalsLoading, setGoalsLoading] = useState(false);
    const you = useUser()
    const ref = useRef<HTMLDivElement>(null)
    const {updateUser} = useAuth();
    const [layerImg, setLayerImg] = useState<TFile>()
    //const hello = useScrollRefresh(ref, ()=>{})
     //-- console.log({userId})
    useEffect(() =>{
       
        
  
       fetchUser();
       fetchDays();

  
        return () =>{
        }
    },[])
    function fetchUser(){
        if(userLoading) return;
        setUserLoading(true)
        if(userId) getUser(userId).then(res => {
            setUserLoading(false)
            setUser(res)
        }).catch(err =>{
            setUserLoading(false)
             //-- console.log("cannot load user")
        })
        
    }
    function updateMe(){
        getUser(me._id).then(res =>updateUser(res));
    }
    function fetchDays(){
        if(goalsLoading) return;
        setGoalsLoading(true)
          getDays(userId).then((res) =>{

            setGoals(res);
            setGoalsLoading(false);
        }
        ).catch(err => {
             setGoalsLoading(false)
             //-- console.log(err)
        })
    }
   
    
    return (
        <>
        <PageHeader title={"Profile"} action={<IoMdRefresh size={24} onClick={()=>{
                fetchUser();
                fetchDays();
                updateMe();

            }}/>} goBack={() => window.history.back()}/>
    
      
        <div id='user' className='content' >
             {layerImg? <div className='layer' onClick={()=>setLayerImg(undefined)}>
        <img className='layer-img' src={ `https://res.cloudinary.com/dkpz7szp2/image/upload/${layerImg.public_id}`}></img>
       </div>: null}
           {userLoading?<div ><Loader size={40}></Loader></div> : 
        user? <>
        <div className='info'>
            <div onClick={() => {
                if(user.profileImg) setLayerImg(user.profileImg)
                }}>
             <ProfileIcon  name={user.name} _id={user._id} profileImg={user.profileImg}  />
            </div>
           
            <div className='text'>
                <h2>{user.name}</h2>
                {/* <p>{user.bio || "empty bio for the moment..."}</p> */}
                {user.goals.length > 0? <p style={{fontSize: 15}}> -  {user.goals.map(goal => goal.title.toUpperCase() + "  -  ")}</p>: null}
                <p className='user-bio'>{user.bio}</p>
                <FriendButton friend={user}/>
            </div> 
       </div>
       {user.profileType == "private" && !me.following.find(f => f == user._id)? 
        null:
       <div className='activities'>
        <h2>Goals</h2>
        
        {goalsLoading? <p>loading</p>: <UserDays days={goals} goals={user?.goals!} setGoals={setGoals} />}
        <h2>Stats</h2>
       <StatsProviderV2 user={user}>
            <Graph/>
        </StatsProviderV2>
       </div>
        }
        </>: <p>user not found</p>}
       

        </div>

        </>
    );
}

export default User;
